import { version } from '../../package.json'

export const environment = {
  production: false,
  apiUrl: 'https://dev-api.premises.billdeo.com',
  apiAuthUrl: 'https://dev-auth.billdeo.com',
  //apiUrl: 'https://api.premises.billdeo.com',
  //apiAuthUrl: 'https://auth.billdeo.com',
  clientId: 'MobileApp',
  appVersion: version,
};
